module.exports = __webpack_public_path__ + "img/kuaidi.f52c278.webp";